import React, { useEffect, useMemo, useRef, useState } from "react";
import ChatbotTitle from "../chatbotTitle/chatbotTitle";
import DangerGigantBtn from "../dangerGigantBtn/dangerGigantBtn";
import ChatbotInput from "../chatbotInput/chatbotInput";
import ChatbotUserMsg from "../chatbotUserMsg/chatbotUserMsg";
import ChatbotResponseMsg from "../chatbotResponseMsg/chatbotResponseMsg";

const btnSteps = [
    {
        title: "Pulsa el botón rojo",
        label: "Solicitar acceso",
        sublabel: "parece inestable - procede con cautela"
    },
    {
        title: "Que raro, mmm, vuelve a darle?",
        label: "Cuidado! Peligroso!",
        sublabel: "perro peligroso suelto"
    },
    {
        title: "Ah ya veo el fallo. Ahora sí, dale.",
        label: "Firulais no es un juego",
        sublabel: "estás vendiendo tu alma al diablo"
    },
    {
        title: "Parece que no funciona, habla con el Admin.",
    }
]

const ChatbotNoRights = () => {

    const [showBtn, setShowBtn] = React.useState(false);
    const [selectedBtnStep, setSelectedBtnStep] = React.useState(0);
    const [titles, setTitles] = useState(["Parece que no tienes acceso a Firulais AI", "¿Quieres tener acceso?"])
    const [showInput, setShowInput] = React.useState(false);
    const [msgSent, setMsgSent] = React.useState(undefined);
    const [response, setMsgResponse] = React.useState(undefined);

    useEffect(() => {
        if (titles.includes(btnSteps[selectedBtnStep].title)) {
            return;
        }

        setTimeout(() => {
            setTitles((prev) => [...prev, btnSteps[selectedBtnStep].title]);
        }, 500);

    }, [titles, selectedBtnStep]);


    return (
        <>

            <ChatbotTitle
                titles={titles}
                onCompleteLast={() => {
                    setTimeout(() => {
                        if (btnSteps.length > selectedBtnStep + 1) {
                            setShowBtn(true);
                        } else {
                            setShowInput(true);
                        }
                    }, 200);
                }} />

            {showBtn && <div style={{
                transition: "opacity 0.6s ease 0.4s",
                position: "absolute",
                bottom: "30%",
                width: "100%",
                opacity: showBtn ? 1 : 0,
                pointerEvents: showBtn ? "auto" : "none",
                cursor: showBtn ? "auto" : "none",
            }}>
                <DangerGigantBtn
                    label={btnSteps[selectedBtnStep].label}
                    sublabel={btnSteps[selectedBtnStep].sublabel}
                    onClick={() => {
                        setShowBtn(false);
                        setSelectedBtnStep((prev) => (prev + 1) % btnSteps.length);
                    }} />
            </div>}
            <div style={{
                transition: "opacity 0.6s ease 0.4s",
                position: "absolute",
                top: "40%",
                width: "100%",
            }}>
                {msgSent && <ChatbotUserMsg isFirst={true} msg={{text: msgSent}}/>}
                {msgSent && <ChatbotResponseMsg thinkingText="Conectando con el admin " isThinking={msgSent && !response} msg={{text: response}}/>}
            </div>
            {showInput && <ChatbotInput placeholder="Escribe tu mensaje..." isLoading={msgSent} touched={true} sendMessage={(value) => {
                setMsgSent(value);
                setTimeout(() => {
                    setMsgResponse("Hola, esto no es para nada un mensaje autogenerado, hablame por wasap que por aquí me va mal.");
                }, 3000);
            }}/>}
        </>
    )
}

export default ChatbotNoRights;